import { defineStore } from 'pinia';
import { Store } from '@/setup/globals';
import { setInitialData } from '@/stores/initial-data';
import useSessionStore from '@/stores/session';
import getApiUrl from '@/helpers/get-api-url';
import { Pagination } from '@/helpers/pagination';
import { ApiDownloadCenterAssetList } from '@/types/api-response';
import { DownloadCenterAsset } from '@/types/download-center-asset';

export type StoreState = {
  assets: DownloadCenterAsset[] | null;

  /**
   * Holds the currently running requests.
   */
  runningRequests: {
    apiFetchDownloadCenterAssets: boolean;
  };
};

const storeName = Store.DownloadCenter;

export default defineStore(storeName, {
  state: () => {
    const state: StoreState = {
      assets: null,

      runningRequests: {
        apiFetchDownloadCenterAssets: false,
      },
    };

    const initialData: StoreState = window.initialData?.[storeName] || {};

    setInitialData(state, initialData);

    return state;
  },
  actions: {
    async apiFetchDownloadCenterAssets(filter: string, pagination: Pagination): Promise<ApiDownloadCenterAssetList> {
      this.runningRequests.apiFetchDownloadCenterAssets = true;

      const sessionStore = useSessionStore();
      const url = getApiUrl('getDownloadCenter', {
        locale: sessionStore.locale,
        limit: String(pagination.numItemsPerPage),
        // In order to avoid duplicate page search param, we do not pass it here as parameter directly
        // Page parameter is part of filters for download center page to make the link shareable
        filter,
      });

      try {
        const response = await this.$api.get(url);

        response.data.pagination.current = response.data.pagination?.current || 1;

        if ('data' in response) {
          return response.data;
        }

        throw new Error('API failure during "getDownloadCenter" request.');
      } finally {
        this.runningRequests.apiFetchDownloadCenterAssets = false;
      }
    },
  },
});
